// frontend/src/pages/LoginPage.js
import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import api from '../api'
import { setAuth } from '../auth'
import { useCurrentBasho } from '../hooks/useCurrentBasho'

export default function LoginPage() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [rememberMe, setRememberMe] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { basho, day } = useCurrentBasho()

  const handleSubmit = async e => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const res = await api.post('/auth/login', { username, password })
      setAuth(res.data, rememberMe)
      navigate(`/picks/${basho}/${day}`)
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={s.page}>
      <div style={s.card}>
        <Link to="/" style={s.backHome}>← Home</Link>

        {/* Seal */}
        <div style={s.sealWrap}>
          <div style={s.seal}><span style={s.sealText}>相撲{'\n'}番付</span></div>
        </div>

        <div style={s.logoArea}>
          <h1 style={s.logoText}>Sign In</h1>
          <p style={s.tagline}>Sumo Pick'em</p>
        </div>

        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.field}>
            <label style={s.label}>Username</label>
            <input
              value={username}
              onChange={e => setUsername(e.target.value)}
              required autoFocus style={s.input}
              placeholder="your username"
            />
          </div>
          <div style={s.field}>
            <label style={s.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required style={s.input}
              placeholder="••••••••"
            />
          </div>
          <div style={s.passwordMeta}>
            <label style={s.checkRow}>
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={e => setRememberMe(e.target.checked)}
                style={s.checkbox}
              />
              <span style={s.checkLabel}>Remember me</span>
            </label>
            <Link to="/forgot-password" style={s.forgotLink}>Forgot password?</Link>
          </div>
          {error && <p style={s.error}>{error}</p>}
          <button type="submit" disabled={loading} style={s.btn}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <p style={s.footer}>
          Need an account?{' '}
          <Link to="/signup" style={s.link}>Sign up</Link>
        </p>
      </div>
    </div>
  )
}

const font = "'Noto Serif JP', Georgia, serif"
const ink = '#1A0A00'
const muted = '#8A7A5A'
const accent = '#C41E3A'

const s = {
  page: {
    minHeight: '100vh',
    background: '#F5F0E8',
    backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 3px, rgba(180,160,120,0.06) 3px, rgba(180,160,120,0.06) 4px)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
  },
  card: {
    background: '#FFFFFF', border: '1px solid #D4C8A8', borderRadius: 4,
    padding: '40px 36px', width: '100%', maxWidth: 380,
    boxShadow: '0 4px 24px rgba(42,26,14,0.08)', position: 'relative',
  },
  backHome: {
    position: 'absolute', top: 18, left: 22,
    color: muted, textDecoration: 'none', fontFamily: font, fontSize: 12,
    letterSpacing: 1,
  },
  sealWrap: { textAlign: 'center', marginBottom: 12 },
  seal: {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    width: 48, height: 48, background: accent, borderRadius: 4,
  },
  sealText: {
    color: '#F5F0E8', fontSize: 9, fontWeight: 700, textAlign: 'center',
    lineHeight: 1.3, whiteSpace: 'pre', fontFamily: font,
  },
  logoArea: { textAlign: 'center', marginBottom: 28 },
  logoText: { fontFamily: font, fontSize: 22, fontWeight: 900, color: ink, margin: '0 0 4px' },
  tagline: { color: muted, fontFamily: font, fontSize: 12, margin: 0, letterSpacing: 1 },
  form: { display: 'flex', flexDirection: 'column', gap: 14 },
  field: { display: 'flex', flexDirection: 'column', gap: 5 },
  label: { fontSize: 10, color: muted, fontFamily: font, letterSpacing: 1, textTransform: 'uppercase' },
  input: {
    padding: '10px 12px', background: '#FDFBF7',
    border: '1px solid #D4C8A8', borderRadius: 2,
    color: ink, fontSize: 14, fontFamily: font, outline: 'none',
    width: '100%', boxSizing: 'border-box',
  },
  passwordMeta: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    marginTop: 2,
  },
  checkRow: {
    display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer',
  },
  checkbox: { accentColor: accent, width: 14, height: 14, cursor: 'pointer' },
  checkLabel: { fontSize: 12, color: muted, fontFamily: font },
  error: { color: accent, fontFamily: font, fontSize: 12, margin: 0 },
  btn: {
    padding: '12px', background: accent, color: '#F5F0E8',
    border: 'none', borderRadius: 2, fontSize: 11, fontWeight: 700,
    fontFamily: font, cursor: 'pointer', letterSpacing: 3, textTransform: 'uppercase',
    marginTop: 4, position: 'relative',
  },
  footer: { textAlign: 'center', marginTop: 20, color: muted, fontFamily: font, fontSize: 12 },
  link: { color: accent, textDecoration: 'none' },
  forgotLink: { color: muted, textDecoration: 'none', fontFamily: font, fontSize: 11, letterSpacing: 0.3 },
}
